import { useSelector } from 'react-redux';

import { selectCurrentMaster } from '../selectors';

export default function useCurrentMaster() {
  return useSelector(selectCurrentMaster);
}
